<template>
  <div>
    <img src="@/assets/froot_logo.jpg" alt="Loading Froot Wheel" width="100%"/>
    <template v-if="valid === 0">
      <br><br>
      There was problem, please please call <nobr>(818) 725-6818.</nobr>
    </template>
    <template v-if="valid === 2">
      <br><br>
      Congratulations! You just won ${{dollar_won}}!<br><br>
      We will reach out to your phone # <nobr>{{phone}}</nobr><br><br>
      Someone from our team will be reaching out to you shortly!<br><br>
      If you have any questions please call <nobr>(818) 725-6818</nobr><br><br>
    </template>
  </div>
</template>


<script>
export default {
  name: 'Info',
  components: {
  },
  data() {
    return {
    };
  },
  props: {
    code: null,
    full_name: null,
    phone: null,
    dollar_won: null,
    valid: null,
    id_number: null,
  },
}
</script>
